<script>
import {
  pageCommanderConfirmationOkProps,
  usePageCommanderConfirmationOk
} from "./mixin";

import OrderConfirmation from "@/components/organisms/order-confirmation";

export default {
  components: {
    OrderConfirmation
  },
  props: {
    ...pageCommanderConfirmationOkProps()
  },
  setup(props) {
    const {
      isEligibleAbonnementLad,
      montantMinimumLAD,
      magasin,
      paniersGroupedByTypePanier,
      montantTotalByTypePanier,
      isPorteurCarteCora,
      isPorteurCarteMalin,
      isEligibleDefis,
      service,
      calendarOptions,
      abonnementInCurrentMagasin,
      created
    } = usePageCommanderConfirmationOk(props);

    created();

    return {
      isEligibleAbonnementLad,
      montantMinimumLAD,
      magasin,
      paniersGroupedByTypePanier,
      montantTotalByTypePanier,
      isPorteurCarteCora,
      isPorteurCarteMalin,
      isEligibleDefis,
      service,
      calendarOptions,
      abonnementInCurrentMagasin
    };
  }
};
</script>

<template>
  <div
    id="content"
    role="main"
  >
    <OrderConfirmation
      v-if="commande && calendarOptions"
      :commande="commande"
      :calendar-options="calendarOptions"
      :service="service"
      :is-porteur-carte-cora="isPorteurCarteCora"
      :is-porteur-carte-malin="isPorteurCarteMalin"
      :paniers="paniersGroupedByTypePanier"
      :montant-paniers="montantTotalByTypePanier"
      :is-eligible-abonnement-lad="isEligibleAbonnementLad"
      :abonnement-in-current-magasin="abonnementInCurrentMagasin"
      :montant-minimum-l-a-d="montantMinimumLAD"
      :magasin="magasin"
      :is-eligible-defis="isEligibleDefis"
    />
  </div>
</template>
